import { getHostport } from "./hostport.js";

// Lazy string-like value so `${baseURL}/path` runs getHostport() when the request
// is made (browser), not only when the module is first evaluated.
function apiBase() {
  return getHostport();
}

export const baseURL = {
  [Symbol.toPrimitive]() {
    return apiBase();
  },
  toString() {
    return apiBase();
  },
  valueOf() {
    return apiBase();
  },
};
